import { retry } from "@reduxjs/toolkit/query";
import React, { useEffect, useState } from "react";
import InputAHSF from "../../../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import {
  AddSU_NT_MRI_PublishedSientific,
  GetOneSU_NT_MRI_PublishedSientificResearch,
  UpdateSU_NT_MRI_PublishedSientific,
} from "../../../../Redux/Reducers/Submitter/PublishedScientificRes";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";
import $ from "jquery";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import { GetAllSU_NT_MRI_CountryOfRegistration } from "../../../../Redux/Reducers/Submitter/MainResearcherInformation/DropDown";
import {
  AddSU_NT_MRI_Patents,
  GetOneSU_NT_MRI_Patents,
  UpdateSU_NT_MRI_Patents,
} from "../../../../Redux/Reducers/Submitter/Patents";

const AddEditePatents = (props) => {
  const dispatch = useDispatch();
  const AppGuid = useParams();
  const [validateLink, setvalidateLink] = useState(false);
  const [validatenumber, setvalidatenumber] = useState(false);
  const [validatecountryOfRegistrationId, setvalidatecountryOfRegistrationId] =
    useState(false);

  const [editValue, setEditValue] = useState(null);
  const [editText, setEditText] = useState(null);

  const urlRegex = /^(https?:\/\/)?(www\.)?[\w-]+(\.[\w-]+)+([\/?#][^\s]*)?$/i;

  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
      Patents: state.Patents.Patents,
      loadingPatents: state.Patents.loadingPatents,
      DropDownCountryOfRegistration:
        state.DropDown.DropDownCountryOfRegistration,
    };
  });
  const [list, setList] = useState({
    countryOfRegistrationId: null,
    number: null,
    link: null,
    applicationInformationId:
      localStorage.getItem("ApplicationInformationId") ||
      decryptToken(AppGuid.AppGuid),
  });
  const [show, setShow] = useState(false);
  const addPatents = async () => {
    if (
      list.link &&
      urlRegex.test(list.link) &&
      list.number != "" &&
      list.number != null &&
      list.countryOfRegistrationId != "" &&
      list.countryOfRegistrationId != null
    ) {
      const add = await dispatch(
        AddSU_NT_MRI_Patents({
          countryOfRegistrationId: list?.countryOfRegistrationId,
          number: list?.number,
          link: list?.link,
          applicationInformationId:
            localStorage.getItem("ApplicationInformationId") ||
            decryptToken(AppGuid.AppGuid),
        })
      );

      if (add.payload) {
        $(".close-btn").trigger("click");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم اضافة المعلومات بنجاح", // "Information updated successfully"
          showConfirmButton: false,
          timer: 1500, // Display success message for 1.5 seconds.
        });

        // Refresh the table by dispatching the action to update the table data.
        dispatch(setRefreshTable());
      }
    } else {
      if (!list.link || !urlRegex.test(list.link)) {
        setvalidateLink(true);
      }
      if (list.number == "" || list.number == null) {
        setvalidatenumber(true);
      }
      if (
        list.countryOfRegistrationId == "" ||
        list.countryOfRegistrationId == null
      ) {
        setvalidatecountryOfRegistrationId(true);
      }
    }
  };

  const updatePatents = async () => {
    if (
      list.link &&
      urlRegex.test(list.link) &&
      list.number != "" &&
      list.number != null &&
      list.countryOfRegistrationId != "" &&
      list.countryOfRegistrationId != null
    ) {
      const update = await dispatch(
        UpdateSU_NT_MRI_Patents({
          patentsId: props.patentsId,
          countryOfRegistrationId: list?.countryOfRegistrationId,
          number: list?.number,
          link: list?.link,
          applicationInformationId: list.applicationInformationId,
        })
      );

      if (update.payload) {
        $(".close-btn").trigger("click");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم تعديل المعلومات بنجاح", // "Information updated successfully"
          showConfirmButton: false,
          timer: 1500, // Display success message for 1.5 seconds.
        });

        // Refresh the table by dispatching the action to update the table data.
        dispatch(setRefreshTable());
      }
    } else {
      if (!list.link || !urlRegex.test(list.link)) {
        setvalidateLink(true);
      }
      if (list.number == "" || list.number == null) {
        setvalidatenumber(true);
      }
      if (
        list.countryOfRegistrationId == "" ||
        list.countryOfRegistrationId == null
      ) {
        setvalidatecountryOfRegistrationId(true);
      }
    }
  };

  const getData = async () => {
    if (props.canEdit) {
      const data = await dispatch(GetOneSU_NT_MRI_Patents(props.patentsId));

      if (data.payload) {
        setList({ ...data.payload });
        setShow(true);
      }
    } else {
      setShow(true);
    }
  };
  useEffect(() => {
    getData();
    dispatch(GetAllSU_NT_MRI_CountryOfRegistration());
  }, []);
  return !state.loadingPatents && show ? (
    <>
      <div className="AddEdite">
        {/* <AllDropDownsAHSF
          fieldsName="CountryOfRegistration"
          show={true}
          disabled={props.shouldDisableFields}
          KeyText={"countryOfRegistrationName"}
          KeyValue={"countryOfRegistrationId"}
          arrayOoptionList={state.DropDownCountryOfRegistration}
          dropdownType={"normal"}
          onChange={(e) => {
            setList({
              ...list,
              countryOfRegistrationId: e.target.value,
            });
          }}
          defaultValue={list?.countryOfRegistrationId}
          showValidationMessage={validatecountryOfRegistrationId}
          validationMessage="يرجى تعبئة هذا الحقل"
        /> */}
        <AllDropDownsAHSF
          fieldsName="CountryOfRegistration"
          hidelable={false}
          labelName={"بلد التسجيل"}
          show={true}
          disabled={props.shouldDisableFields}
          valueEdite={list?.countryOfRegistrationId}
          submissionStatus={props.canEdit ? "edite" : ""}
          textEdite={
            props.canEdit
              ? list?.sU_NT_MRI_CountryOfRegistration?.countryOfRegistrationName
              : editText
          }
          arrayOoptionList={state.DropDownCountryOfRegistration}
          KeyText={"countryOfRegistrationName"}
          id={"countryOfRegistrationId"}
          dropdownType={"search"}
          defaultValue={list?.countryOfRegistrationId}
          value={list?.countryOfRegistrationId}
          OnClickLi={(e) => {
            setEditValue(e.countryOfRegistrationId);
            setEditText(e.countryOfRegistrationName);
            setList({
              ...list,
              countryOfRegistrationId: e.countryOfRegistrationId,
            });
          }}
          showValidationMessage={validatecountryOfRegistrationId}
          validationMessage="يرجى تعبئة هذا الحقل"
          //   defaultValue={AdvertisingList.mP_MR_ItemId}
        />
        <InputAHSF
          fieldsName="Number"
          type="number"
          show={true}
          disabled={props.shouldDisableFields}
          onChange={(e) => {
            setList({
              ...list,
              number: e.target.value,
            });
          }}
          defaultValue={list?.number}
          showValidationMessage={validatenumber}
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        {state.jsonData ? (
          <p className="linkMassage">{state.jsonData?.LinkMassage}</p>
        ) : (
          ""
        )}

        <InputAHSF
          fieldsName="link"
          // type={"url"}
          show={true}
          disabled={props.shouldDisableFields}
          onChange={(e) => {
            setList({
              ...list,
              link: e.target.value,
            });
            setvalidateLink(false); // reset on change
          }}
          onBlur={(e) => {
            if (!urlRegex.test(e.target.value)) {
              setvalidateLink(true);
            }
          }}
          defaultValue={list?.link}
          showValidationMessage={validateLink}
          validationMessage={list?.link?"يرجى تعبئة رابط صحيح":"يرجى تعبئة هذا الحقل"}
        />
        {!props.shouldDisableFields ? (
          <div className="containersButton">
            <div>
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  props.canEdit == "edit" ? updatePatents() : addPatents();
                }}
                disabled={false}
                title={props.canEdit == "edit" ? "تعديل" : "اضافة"}
                text={props.canEdit == "edit" ? "تعديل" : "اضافة"}
                show={true}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  ) : (
    ""
  );
};

export default AddEditePatents;
